export default "__VITE_ASSET__DSgswxvE__"